import styled from '@emotion/styled'
import { radius, spacing, font, colors } from '@mobi/component-library/Theme/Common'
import { gapY, gapX } from '@mobi/component-library/Utils/gap'

export const Selector = styled.div(
  {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.surface[100],
    border: `0.1rem solid ${colors.neutral[200]}`,
    borderRadius: radius.lgx1,
    padding: `0rem  ${spacing.md} ${spacing.md}`,
  },
  gapY(spacing.md)
)

export const SelectorHeading = styled.div(
  {
    alignItems: 'center',
    display: 'flex',
    padding: '1.6rem 0',
    ...font.size.md,
    '> div': { flex: 1 },
  },
  gapX(spacing.sm)
)

export const MessageContainer = styled.div(
  {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    fontFamily: font.family.primary,
    '> div:first-of-type': { fontWeight: font.weight.semibold, ...font.size.md },
    '> div:nth-of-type(2)': { color: colors.neutral[800], ...font.size.base },
  },
  gapY(spacing.smx2)
)

export const ToggleGroupItem = styled.div(
  {
    display: 'grid',
    position: 'relative',
    gridTemplateColumns: 'auto 1fr auto auto',
    alignItems: 'center',
    fontFamily: font.family.primary,
    fontWeight: font.weight.medium,
    ...font.size.lg,
    color: colors.neutral['900'],
    borderRadius: radius.lgx1,
    backgroundColor: colors.white,
    border: `1px solid ${colors.neutral['200']}`,
    '&:focus-within': {
      outlineColor: colors.lavender['50'],
    },
    marginRight: '1rem',
    padding: spacing.md,
  },
  gapX(spacing.sm)
)

export const ChildrenContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
})
